import type { KerningOverrides } from "./types";

const isClearValue = (value: number | null | undefined): boolean =>
  value === null ||
  value === undefined ||
  Number.isNaN(value) ||
  value === 0;

export const mergeKerningOverride = (
  prev: KerningOverrides | undefined,
  index: number,
  value: number | null | undefined
): KerningOverrides | undefined => {
  if (!Number.isInteger(index) || index < 0) return prev;
  const next: KerningOverrides = { ...(prev ?? {}) };
  if (isClearValue(value)) {
    delete next[index];
  } else {
    next[index] = value as number;
  }
  return Object.keys(next).length > 0 ? next : undefined;
};

export const adjustKerningOverride = (
  prev: KerningOverrides | undefined,
  index: number,
  delta: number
): KerningOverrides | undefined => {
  const current = prev?.[index] ?? 0;
  return mergeKerningOverride(prev, index, current + delta);
};

export const adjustKerningOverrideRange = (
  prev: KerningOverrides | undefined,
  startInclusive: number,
  endExclusive: number,
  delta: number
): KerningOverrides | undefined => {
  let next = prev;
  for (let i = startInclusive; i < endExclusive; i++) {
    next = adjustKerningOverride(next, i, delta);
  }
  return next;
};
